import React, {useState, useEffect} from 'react';
import '../CSS/contact.css';
import { withRouter } from 'react-router';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Button from '@material-ui/core/Button';
import Row from 'react-bootstrap/Row';





const ContactForm = (props) => {



    const buttonStyle = {
        marginTop: "20px",
        backgroundColor: "rgb(20, 150, 255)",
        outline: "none",
        padding: "10px",
        fontWeight: "500",
        color: "white"
    }

    const initialValues = {
        fullName: '',
        email: '',
        message: ''
    }

    var [values, setValues] = useState(initialValues)

    const handleChange = e => {
        var { name, value } = e.target
        setValues({
            ...values, 
            [name]: value,
        })

    }

    const handleSubmit = e => {
        const templateId = 'template_27lN0xQd';
        e.preventDefault();
        props.add(values);
        props.sendFeedback(templateId, {message_html: values.message, from_name: values.fullName, reply_to: values.email, to_email: values.email });
        props.history.push(`/`);
    }

    


    return(
        <div style={{backgroundColor: "#f2f6f9"}} className="formArea">
            <Container>
                <form onSubmit={handleSubmit} className="formHere">
                    <Row>
                    <Col md={6} style={{padding: "20px"}}>
                        <label style={{fontWeight: "900"}}>Full Name</label>
                        <input type="text" id="fname" name="fullName" placeholder="Name..."
                            value={values.fullName}
                            onChange={handleChange}
                        />
                    </Col >

                    <Col md={6} style={{padding: "20px"}}>
                        <label style={{fontWeight: "900"}}>Email</label>
                        <input type="email" id="email" name="email" placeholder="Email..."
                            value={values.email}
                            onChange={handleChange}
                        />
                     </Col >

                     <Col md={12} style={{padding: "20px"}}>
                        <label style={{fontWeight: "900"}}>Message</label>
                        <textarea id="message" name="message" placeholder="Write something.."
                            value={values.message}
                            onChange={handleChange}
                        ></textarea>
                    </Col>
                    <Col md={12} style={{padding: "20px"}}>
                        <Button variant="contained" disabled={!values.email} type="submit" disableElevation style={buttonStyle}>
                            Submit
                        </Button>
                    </Col>
                    </Row>
                </form >
            </Container>
        </div>

    );
}

export default withRouter(ContactForm);